import { CreateAccountContext } from '@views/contexts'
import { useContext } from 'react'

export const useCreateAccount = () => useContext(CreateAccountContext)
